module.exports = __webpack_public_path__ + "static/media/YoudBeSoNiceToComeHomeTo_200.0ad01a37.jpg";